






































































































































import Vue from "vue";
import * as R from "ramda";
import bcrypt from "bcryptjs";

import { ApolloQueryResult } from "apollo-client";

import USER from "@/graphql/users/User.gql";
import USER_CREATE from "@/graphql/users/UserCreate.gql";
import USER_UPDATE from "@/graphql/users/UserUpdate.gql";
import USERS from "@/graphql/users/Users.gql";
import PROJECTS from "@/graphql/projects/Projects.gql";

import {
  User_user,
  User,
  Projects,
  Projects_projects_edges
} from "@/api-types";

export default Vue.extend({
  props: {
    editUser: String
  },
  data: function() {
    return {
      form: {} as User_user | null,
      showPassword: false,
      selectedTools: {} as { [key: string]: string[] },
      availableTools: {} as { [key: string]: { id: string; name: string }[] },
      availableRoles: [
        { value: "ROLE_USER", text: "Benutzer" },
        { value: "ROLE_PROJECTMANAGER", text: "Projektleiter" },
        { value: "ROLE_ADMIN", text: "Administrator" }
      ],
      passwordRules: [
        (v: string) =>
          this.editUser !== "new" || !!v || "Bitte ein Passwort eingeben",
        (v: string) =>
          !v || v.length >= 8 || "Passwort muss mindestens 8 Zeichen lang sein"
      ],
      selectedRole: "ROLE_USER",
      usernameRules: [(v: string) => !!v || "Bitte Benutzername eingeben"],
      roleRules: [(v: string) => !!v || "Bitte Benutzerrolle auswählen"],
      emailRules: [
        (v: string) => !!v || "Bitte E-Mail-Adresse eingeben",
        (v: string) => /.+@.+/.test(v) || "E-Mail-Adresse ist ungültig"
      ]
    };
  },
  apollo: {
    user: {
      query: USER,
      variables() {
        return { id: this.editUser };
      },
      result({ data }: ApolloQueryResult<User>) {
        this.form = R.clone(data.user);
        this.form!.password = "";
        this.selectedRole = data.user!.roles[0];
        const toolNames = [
          "damageTables",
          "hdrViewers",
          "bimViewers",
          "viewer3ds",
          "gisWebs"
        ];

        const setTools = (toolName: string) => {
          (this.form as any)[toolName] = R.compose(
            R.map(R.path(["id"])),
            (edges: any) => R.pluck("node")(edges),
            R.path(["user", toolName, "edges"])
          )(data) as any;
        };
        R.forEach(setTools, toolNames);

        R.forEachObjIndexed((toolCollection, projectId) => {
          this.selectedTools[projectId] = [];
          R.forEach(tool => {
            if (R.includes(tool.id, data.user!.toolIds)) {
              this.selectedTools[projectId].push(tool.id);
            }
          }, toolCollection);
        }, this.availableTools);
      },
      skip() {
        return !this.editUser.startsWith("/users");
      }
    },
    projects: {
      query: PROJECTS,
      result({ data }: ApolloQueryResult<Projects>) {
        R.forEach(
          (edge: Projects_projects_edges) => {
            this.availableTools[edge.node!.id] = [];
            R.compose(
              R.forEachObjIndexed((value: any, __) => {
                if (value)
                  this.availableTools[edge.node!.id].push({
                    id: value.id,
                    name: value.name
                  });
              }),
              R.pick([
                "damageTable",
                "hdrViewer",
                "bimViewer",
                "viewer3d",
                "gisWeb"
              ])
            )(edge.node! as any);
          },
          data.projects!.edges as any
        );
      }
    }
  },
  methods: {
    save(): void {
      if (!(this.$refs.form as any).validate()) return;

      let mutation;
      if (this.editUser === "new") {
        mutation = USER_CREATE;
        delete this.form!.id;
      } else {
        mutation = USER_UPDATE;
      }

      this.form!.roles = [this.selectedRole];

      const toolIds = [] as string[];
      const tools = R.forEachObjIndexed((ids, __) => {
        R.forEach(id => {
          toolIds.push(id);
        }, ids);
      }, this.selectedTools);

      let groupedTools = {
        damageTables: [],
        hdrViewers: [],
        bimViewers: [],
        viewer3ds: [],
        gisWebs: []
      };

      groupedTools = {
        ...groupedTools,
        ...R.groupBy(id => {
          const camelCase = R.replace(
            /_(.)/g,
            $1 => R.toUpper($1).substring(1),
            R.split("/", id)[1]
          );
          return camelCase;
        }, toolIds)
      };

      if (this.form!.password) {
        this.showPassword = false;
        this.form!.password = bcrypt.hashSync(this.form!.password, 13);
      } else {
        delete this.form!.password;
      }

      this.$apollo
        .mutate({
          mutation,
          variables: {
            input: {
              ...R.omit(["__typename", "toolIds"], this.form),
              ...groupedTools
            }
          },
          refetchQueries: [
            {
              query: USERS
            }
          ]
        })
        .then(() => {
          this.$apollo.queries.user.refetch(),
            this.$apollo.queries.projects.refetch(),
            this.close();
        });
    },
    generatePassword() {
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let pass = "";
      for (var i = 0; i < 8; i++) {
        pass += characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
      }
      this.form!.password = pass;
      this.showPassword = true;
    },
    close() {
      this.$emit("close");
    }
  },
  mounted: function() {
    this.form = {
      __typename: "User",
      username: "",
      password: "",
      forename: "",
      surename: "",
      info: "",
      id: "",
      email: "",
      roles: ["ROLE_USER"],
      toolIds: [],
      damageTables: null,
      hdrViewers: null,
      bimViewers: null,
      viewer3ds: null,
      gisWebs: null
    };
  }
});
